import { create } from 'zustand';
import { DateRange } from 'react-day-picker';
import { ColumnState } from 'ag-grid-community';
import { defaultMST1011_R01Dto, MST1011_R01Dto } from './Dto_MST1011_R01';
import { allCd, useCommonCodeStore } from 'src/store/useCommonCodeStore';

export interface MST1011_R01Filter {
	brandCd: string;
	itemGroup: string;
	itemAccount: string;
	itemCd: string;
	itemNm: string;
}

export interface Store_MST1011_R01 {
	MST1011_R01Filter: MST1011_R01Filter;
	MST1011_R01PastFilter: MST1011_R01Filter;
	setMST1011_R01Filter: (filter: Partial<MST1011_R01Filter>) => void;
	setMST1011_R01PastFilter: (filter: Partial<MST1011_R01Filter>) => void;

	MST1011_R01List: MST1011_R01Dto[];
	setMST1011_R01List: (MST1011_R01List: MST1011_R01Dto[]) => void;

	selectedMST1011_R01: MST1011_R01Dto | undefined;
	setSelectedMST1011_R01: (item: MST1011_R01Dto | undefined) => void;
	initSelectedMST1011_R01: () => void;

	editMST1011_R01: MST1011_R01Dto | null;
	setEditMST1011_R01: (item: MST1011_R01Dto | null) => void;

	columnState: ColumnState[] | null;
	setColumnState: (state: ColumnState[] | null) => void;

	scrollTop: number | null;
	setScrollTop: (top: number | null) => void;

	allCount: number;				setAllCount: (allCount: number) => void;

	initData: () => void;
}

export const defaultMST1011_R01Filter : MST1011_R01Filter = {
	brandCd: '',
	itemGroup: '',
	itemAccount: '',
	itemCd: '',
	itemNm: '',
};

export const useMST1011_R01Store = create<Store_MST1011_R01>((set) => ({
	MST1011_R01Filter: defaultMST1011_R01Filter,
	MST1011_R01PastFilter: defaultMST1011_R01Filter,
	setMST1011_R01Filter: (filter: Partial<MST1011_R01Filter>) => set((state) =>  ({
		...state,
		MST1011_R01Filter: {
			...state.MST1011_R01Filter,
			...filter
		}	
	})),
	setMST1011_R01PastFilter: (filter: Partial<MST1011_R01Filter>) => set((state) =>  ({
		...state,
		MST1011_R01PastFilter: {
			...state.MST1011_R01PastFilter,
			...filter
		}	
	})),

	MST1011_R01List: [],
	setMST1011_R01List: (MST1011_R01List: MST1011_R01Dto[]) => set({ MST1011_R01List }),

	selectedMST1011_R01: undefined,
	setSelectedMST1011_R01: (item: MST1011_R01Dto | undefined) => set((state) => {

		return { ...state, selectedMST1011_R01: item };
	}),
	initSelectedMST1011_R01: () => set({ selectedMST1011_R01: undefined, editMST1011_R01: defaultMST1011_R01Dto }),
	
	editMST1011_R01: defaultMST1011_R01Dto,
	setEditMST1011_R01: (item: MST1011_R01Dto | null) => set((state) => {
		let editData = defaultMST1011_R01Dto;
		if (item) {
			editData = { ...item };
		}
		return { editMST1011_R01: editData };
	}),

	columnState: null,
	setColumnState: (state: ColumnState[] | null) => set({ columnState: state }),

	scrollTop: null,
	setScrollTop: (top: number | null) => set({ scrollTop: top }),

	allCount: 0,
	setAllCount: (allCount: number) => set({ allCount }),

	initData: () => set((state) => ({
		...state,
		MST1011_R01Filter: defaultMST1011_R01Filter,
		MST1011_R01PastFilter: defaultMST1011_R01Filter,
		selectedMST1011_R01: undefined,
		editMST1011_R01: defaultMST1011_R01Dto,
		MST1011_R01List: [],
		allCount: 0,
		scrollTop: null,
	})),

	
}));
